import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7455 6.66666H17.4364H15.4727V4.66666C15.4727 4.29866 15.1802 4 14.8182 4H9.58182C9.21987 4 8.92728 4.29866 8.92728 4.66666V6.66666H6.96364H5.65454C5.29258 6.66666 5 6.96531 5 7.33331C5 7.70131 5.29255 8 5.65454 8H6.30907V18C6.30907 19.1027 7.19011 20 8.27272 20H16.1273C17.2099 20 18.0909 19.1027 18.0909 18V8H18.7455C19.1074 8 19.4 7.70134 19.4 7.33334C19.4 6.96534 19.1074 6.66666 18.7455 6.66666ZM10.2364 5.33334H14.1636V6.66669H10.2364V5.33334ZM16.7818 18C16.7818 18.3673 16.4886 18.6667 16.1273 18.6667H8.27272C7.91141 18.6667 7.61818 18.3673 7.61818 18V8H9.58182H14.8182H16.7819V18H16.7818Z",
			fill: "#757783"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2366 9.3335C9.87461 9.3335 9.58203 9.63215 9.58203 10.0002V16.0002C9.58203 16.3682 9.87461 16.6668 10.2366 16.6668C10.5985 16.6668 10.8911 16.3682 10.8911 16.0002V10.0002C10.8911 9.63215 10.5985 9.3335 10.2366 9.3335Z",
			fill: "#3A3C45"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1638 9.3335C13.8019 9.3335 13.5093 9.63215 13.5093 10.0002V16.0002C13.5093 16.3682 13.8019 16.6668 14.1638 16.6668C14.5258 16.6668 14.8184 16.3682 14.8184 16.0002V10.0002C14.8184 9.63215 14.5258 9.3335 14.1638 9.3335Z",
			fill: "#3A3C45"
		})
	]
});
const ForwardRef = forwardRef(SvgIcTrash);
export default ForwardRef;
